import { Toast } from 'vant'
import { wxLogin } from '@/api/index.js'
import { setToken } from '@/utils/auth'

let wxLoginRedirectPromise = null

/**
 * 修正错误 hash：#/bind&openId=xxx -> 提取 openId
 * @returns {string} openId，未命中时返回空字符串
 */
export function parseOpenIdFromBadBindHash() {
  const raw = window.location.hash || ''
  const m = raw.match(/#\/bind&openId=([^&?#]+)/i)
  if (!m) return ''
  try {
    return decodeURIComponent(m[1])
  } catch (e) {
    return m[1]
  }
}

/**
 * 从路由 query 提取绑定页 openId
 * @param {Object} to VueRouter 路由对象
 * @returns {string} openId
 */
export function getBindOpenId(to) {
  const q = (to && to.query) || {}
  return q.openId || q.openid || ''
}

/**
 * 判断是否绑定页路由
 * @param {Object} to VueRouter 路由对象
 * @returns {boolean}
 */
export function isBindRoute(to) {
  return to.name === 'bind' || to.path === '/bind'
}

/**
 * 从 URL query 读取 token 并落库，同时清理 URL 参数
 * @param {Object} to VueRouter 目标路由
 * @param {Function} next 路由守卫 next
 * @returns {boolean} true 表示已处理并重定向
 */
export function normalizeUrlToken(to, next) {
  const q = (to && to.query) || {}
  const urlToken = q.token || q.Authorization || q.authorization || ''
  if (!urlToken) return false
  setToken(String(urlToken))
  const cleanedQuery = { ...q }
  delete cleanedQuery.token
  delete cleanedQuery.Authorization
  delete cleanedQuery.authorization
  next({
    path: to.path,
    query: cleanedQuery,
    hash: to.hash,
    replace: true
  })
  return true
}

/**
 * 调用微信授权接口并跳转到 authUrl
 * 多次并发调用时只会触发第一次，后续复用同一个 Promise
 * @returns {Promise<string>} 成功时返回 authUrl
 */
export async function triggerWxLoginByRedirect() {
  if (wxLoginRedirectPromise) {
    return wxLoginRedirectPromise
  }
  wxLoginRedirectPromise = (async () => {
    const res = await wxLogin({
      redirectUrl: window.location.href.split('#')[0] + (window.location.hash || '')
    })
    const authUrl = res.data && res.data.authUrl
    if (!authUrl) {
      Toast.fail('获取微信授权地址失败')
      throw new Error('no authUrl')
    }
    window.location.href = authUrl
    return authUrl
  })().catch((err) => {
    // 失败时允许后续重试
    wxLoginRedirectPromise = null
    throw err
  })
  return wxLoginRedirectPromise
}
